import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "viewBtn", "count", "clearBtn", "filterInput", "filterType", "row"]

  connect() {
    this.maxSelections = 5
    this.updateState()
  }

  filter() {
    const query = this.filterInputTarget.value.trim().toLowerCase()
    const type = this.filterTypeTarget.value

    this.rowTargets.forEach(row => {
      const name = (row.dataset.geoName || "").toLowerCase()
      const geoType = row.dataset.geoType || ""
      const isParent = row.dataset.isParent === "true"

      // Always show parent row
      if (isParent) {
        row.style.display = ""
        return
      }

      const matchesQuery = !query || name.includes(query)
      const matchesType = !type || geoType === type
      row.style.display = (matchesQuery && matchesType) ? "" : "none"
    })
  }

  toggle() {
    this.updateState()
  }

  updateState() {
    const checked = this.checkboxTargets.filter(cb => cb.checked)
    const count = checked.length
    const atMax = count >= this.maxSelections

    this.checkboxTargets.forEach(cb => {
      cb.disabled = atMax && !cb.checked
    })

    if (this.hasViewBtnTarget) {
      this.viewBtnTarget.disabled = count === 0
    }
    if (this.hasCountTarget) {
      this.countTarget.textContent = count > 0 ? `${count} selected` : ""
    }
    if (this.hasClearBtnTarget) {
      this.clearBtnTarget.style.display = count > 0 ? "" : "none"
    }
  }

  clearAll() {
    this.checkboxTargets.forEach(cb => cb.checked = false)
    this.updateState()
  }

  openDashboard(event) {
    event.preventDefault()
    const ids = this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)

    if (ids.length === 0) return

    const params = new URLSearchParams()
    ids.forEach(id => params.append("geography_ids[]", id))
    params.set("period", "90d")
    window.open(`/dashboard?${params.toString()}`, "_blank")
  }
}
